const FETCH_SESSION_MESSAGES = `${process.env.baseUrl}/customer/messages`;

export default FETCH_SESSION_MESSAGES;
